<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="part01"><a id="page_25"></a>MYSTERIUM</h2>
<h2 class="h2a">PART ONE</h2>
<div class="pagebreak">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="extract"><a id="page_27"></a>The void that precedes the creation of the universe is an imponderable, unknowing emptiness—lacking matter, vacuum, time, motion, number, or logic. And yet the universe derives from it according to some law not yet understood—a law which, governing nothingness, yields everything!</p>
<p class="extract-indent">Call it Nous. Perfect Mind. Call it the Protennoia. The Uncreated God.</p>
<p class="right-para">—from the secret journal of Alan Stern</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?86611ed0